/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getPeriodicJobs } from '../fn/admin/get-periodic-jobs';
import { GetPeriodicJobs$Params } from '../fn/admin/get-periodic-jobs';
import { PeriodicJobRecordDto as PlatformPeriodicJobRecordDto } from '../models/platform/periodic-job-record-dto';
import { resetApiUserPassword } from '../fn/admin/reset-api-user-password';
import { ResetApiUserPassword$Params } from '../fn/admin/reset-api-user-password';

@Injectable({ providedIn: 'root' })
export class AdminClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminResetApiUserPassword()` */
  static readonly AdminResetApiUserPasswordPath = '/administration/reset-api-user-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resetApiUserPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetApiUserPassword$Response(body: ResetApiUserPassword$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = resetApiUserPassword(this.http, this.rootUrl, { body } satisfies ResetApiUserPassword$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resetApiUserPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resetApiUserPassword(body: ResetApiUserPassword$Params['body'], context?: HttpContext): Observable<void> {
    const resp = this.resetApiUserPassword$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminGetPeriodicJobs()` */
  static readonly AdminGetPeriodicJobsPath = '/administration/periodic-jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPeriodicJobs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPeriodicJobs$Response(context?: HttpContext): Observable<StrictHttpResponse<Array<PlatformPeriodicJobRecordDto>>> {
    const obs = getPeriodicJobs(this.http, this.rootUrl, {} satisfies GetPeriodicJobs$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPeriodicJobs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPeriodicJobs(context?: HttpContext): Observable<Array<PlatformPeriodicJobRecordDto>> {
    const resp = this.getPeriodicJobs$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PlatformPeriodicJobRecordDto>>): Array<PlatformPeriodicJobRecordDto> => r.body)
    );
  }

}
